import { useEffect, useRef } from 'react';
import { useListPresentationContextData } from '../context/ListPresentationContext';
import { getShift } from '../utils';

export function useAutoRotation() {
  const interval = useRef(null);
  const data = useListPresentationContextData();
  const { isMobile, itemCountTotal, contentTypeConditions } = data.state;
  const { itemContainerRef } = data.refs;
  const { getConfigsAndUtils } = data.utilities;
  const {
    columnWidthShift,
    showAutoRotation,
    columns,
    slideOffset,
    gridGapAxis,
    autoRotateTimer,
    isLayout4,
  } = getConfigsAndUtils().generalValues;

  // handle auto rotation
  useEffect(() => {
    startAutoRotation();
    return () => {
      stopAutoRotation();
      contentTypeConditions.testimonials && switchToInitialState();
    };
  }, [
    itemCountTotal,
    showAutoRotation,
    autoRotateTimer,
    gridGapAxis.columnGap,
    columns,
    columnWidthShift,
    isMobile,
  ]);

  function startAutoRotation() {
    if (itemContainerRef && showAutoRotation) {
      const scrollContainer = itemContainerRef;
      interval.current = setInterval(() => {
        const { remainingShiftForward } = getShift(
          itemContainerRef,
          showAutoRotation,
          slideOffset,
          columnWidthShift
        );

        scrollContainer.scrollTo({
          left: scrollContainer.scrollLeft + remainingShiftForward,
          behavior: isLayout4 ? 'instant' : 'smooth',
        });

        const repeatitionStarted =
          Math.ceil(scrollContainer.scrollLeft) >=
          Math.floor(columnWidthShift * (itemCountTotal - (isLayout4 ? 0 : 1)));

        if (repeatitionStarted) {
          setTimeout(switchToInitialState, 1500);
        }
      }, autoRotateTimer * 1000);
    }
  }

  function switchToInitialState() {
    if (itemContainerRef as HTMLElement) {
      itemContainerRef.scrollTo({
        left: 0,
        behavior: 'instant',
      });
    }
  }

  function stopAutoRotation() {
    if (interval.current) {
      clearInterval(interval.current);
      interval.current = null;
    }
  }

  return { stopAutoRotation, startAutoRotation };
}
